import {LLMVariable} from "@/api/services/lLMVariable";
import {LLMVariableType} from "@/api/services/lLMVariableType";

export enum Operators {
  EQUAL = "equal",
  NOT_EQUAL = "not_equal",
  GREATER_THAN = "greater_than",
  GREATER_OR_EQUAL = "greater_or_equal",
  LESS_THAN = "less_than",
  LESS_OR_EQUAL = "less_or_equal",
  CONTAINS = "contains",
  STARTS_WITH = "starts_with",
  ENDS_WITH = "ends_with",
}

export enum VariableType {
  STRING = "string",
  BOOLEAN = "boolean",
  NUMBER = "number",
  INTEGER = "integer",
  ENUM = "enum",
}

export type OperatorOptionType = {
  name: string;
  value: string;
  icon?: string;
};

export const OperatorOptions: OperatorOptionType[] = [
  {name: "String", value: VariableType.STRING},
  {name: "Number", value: VariableType.NUMBER},
  {name: "Integer", value: VariableType.INTEGER},
  {name: "Boolean", value: VariableType.BOOLEAN},
  {name: "List", value: VariableType.ENUM},
];

const StringOperatorOptions: OperatorOptionType[] = [
  {name: "Equal to", value: Operators.EQUAL, icon: "="},
  {name: "Not equal to", value: Operators.NOT_EQUAL, icon: "≠"},
  {name: "Contains", value: Operators.CONTAINS, icon: "⊃"},
  {name: "Starts with", value: Operators.STARTS_WITH, icon: "^"},
  {name: "Ends with", value: Operators.ENDS_WITH, icon: "$"},
];

const NumberOperatorOptions: OperatorOptionType[] = [
  {name: "Equal to", value: Operators.EQUAL, icon: "="},
  {name: "Not equal to", value: Operators.NOT_EQUAL, icon: "≠"},
  {name: "Greater than", value: Operators.GREATER_THAN, icon: ">"},
  {name: "Less than", value: Operators.LESS_THAN, icon: "<"},
  {name: "Greater or equal", value: Operators.GREATER_OR_EQUAL, icon: "≥"},
  {name: "Less or equal", value: Operators.LESS_OR_EQUAL, icon: "≤"},
];

const BooleanOperatorOptions: OperatorOptionType[] = [
  {name: "Equal to", value: Operators.EQUAL, icon: "="},
  {name: "Not equal to", value: Operators.NOT_EQUAL, icon: "≠"},
];

const EnumOperatorOptions: OperatorOptionType[] = [
  {name: "Contains", value: Operators.CONTAINS, icon: "⊃"},
];

export const TypeOperatorsMap = {
  [VariableType.STRING]: StringOperatorOptions,
  [VariableType.NUMBER]: NumberOperatorOptions,
  [VariableType.INTEGER]: NumberOperatorOptions,
  [VariableType.BOOLEAN]: BooleanOperatorOptions,
  [VariableType.ENUM]: EnumOperatorOptions,
};
